// @flow

import dayjs from "dayjs";

import { ProductStatus } from "./enums";

/// Determines if the execution environment is client or server
/// See https://stackoverflow.com/a/32598826/486434
export const canUseDOM = (): boolean => (
	!!(
		typeof window !== "undefined" &&
		window.document &&
		window.document.createElement
	));

// Remove querystring parameters from a given URL
export const removeQueryParameter =
	(url: string, parameter: string, value: ?string = null): string => {
		const urlParts = url.split("?");

		if (urlParts.length < 2)
			return url;

		let urlParams = urlParts[1].split(/[&;]/g);

		for (var i = urlParams.length; i-- > 0;) {
			const parParts = urlParams[i].split("=");

			if (parParts[0].toLowerCase() === parameter.toLowerCase()
				&& (!value || (value && value.toLowerCase() === (parParts[1] || "").toLowerCase()))) {
				urlParams.splice(i, 1);
			}
		}

		const queryString = (urlParams.length > 0 ? "?" + urlParams.join("&") : "");
		return urlParts[0] + queryString;
	};

export const appendQueryParameter =
	(url: string, parameter: string, value: string): string => `${url}${url.indexOf("?") === -1 ? "?" : "&"}${parameter}=${value}`;

// Map an key of a guidance status to its display name
export const convertStatusToDisplayName =
	(status: string): string => {
		switch(status) {
			case ProductStatus.Published:
				return "Published";
			case ProductStatus.InConsultation:
				return "In consultation";
			case ProductStatus.InDevelopment:
				return "In development";
			case ProductStatus.AwaitingDevelopment:
				return "Awaiting development";
			case ProductStatus.TopicSelection:
				return "Topic prioritisation";
			case ProductStatus.Prioritisation:
				return "Topic prioritisation";
			case ProductStatus.Deferred:
				return "Deferred";
			case ProductStatus.Terminated:
				return "Terminated";
			default:
				throw new Error(`Status must be one of Published, InConsultation, InDevelopment, AwaitingDevelopment, Deferred or Terminated but was ${ status }`);
		}
	};

// Formats a date into a NICE format string, conforming to the NICE style guide.
// See https://www.nice.org.uk/corporate/ecd1/chapter/units-and-symbols
export const toNICEDateString =
	(date: Date | string, withoutDay: boolean = false): string => {
		const formatStr: string =
			withoutDay ? "MMMM YYYY": "D MMMM YYYY";
		return dayjs(date).format(formatStr);
	};
